


















































import Vue from 'vue';
import AsyncMenu from '@/components/AsyncMenu.vue';
import { routes } from '@/router';

export default Vue.extend({
  components: {
    AsyncMenu
  },
  data() {
    return {
      routes: routes
    }
  },
  methods: {
    logout() {
      this.$store.commit('ACCOUNT', null);
      this.$router.replace('/login');
    }
  },
  computed: {
    title(): string {
      return this.$store.state.titleBar || '';
    },
    titleComponent(): any | null {
      return 'AsyncMenu'
    },
    filteredRoutes() {
      const visibleRoutes: any[] = this.routes.filter((r: any) => !r.meta || (r.meta && !r.meta.hidden));

      if (this.$store.state.account && this.$store.state.account.scopes.includes('admin')) {
        return visibleRoutes;
      }

      return visibleRoutes.filter((r: any) => !r.meta || (r.meta && !r.meta.admin));
    }
  }
});
